import React from 'react';
import { footerLinks } from './navData';
import './Layout.css';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer-inner">
        <nav aria-label="Footer">
          {footerLinks.map((link) => (
            <a key={link.href + link.label} href={link.href} rel="noopener noreferrer" target="_blank">
              {link.label}
            </a>
          ))}
        </nav>
        <div className="site-footer-divider" />
        <p className="site-footer-copy">&copy; {year} Blue Compass RV. All Rights Reserved.</p>
      </div>
    </footer>
  );
}
